async function syncWineMembersPrice(context, variantId) {
  const root = context || document;
  const wrap = root.querySelector('.wine-members-div .member-price');
  if (!wrap || !variantId) return;

  if (typeof window.checkProductDiscounts !== 'function') {
    console.warn('checkProductDiscounts function not found');
    return;
  }

  try {
    const customerId = window.currentCustomerId || '';
    const data = await window.checkProductDiscounts(variantId, 'AUD', customerId);

    if (data && data.tierGeneral && data.tierGeneral.tierGeneral && data.tierGeneral.tierGeneralObj.length) {
      const tier = data.tierGeneral.tierGeneralObj[0];
      const priceEl = wrap.querySelector('.price');
      const compareEl = wrap.querySelector('.compare-price s');

      if (priceEl) priceEl.textContent = tier.discountedPrice;
      if (compareEl) compareEl.textContent = tier.regularPrice;

      wrap.hidden = false;
      console.log('Quick View: member price synced via checkProductDiscounts', tier);
    } else {
      console.log('Quick View: no member pricing for this product');
    }
  } catch (err) {
    console.warn('checkProductDiscounts call failed:', err);
  }
}

window.syncWineMembersPrice = syncWineMembersPrice;


document.addEventListener('click', async function (e) {

  // OPEN QUICK VIEW
  const quickView = e.target.closest('.quick-View');
  if (quickView) {
    console.log('Quick View Clicked');
    const handle = quickView.dataset.handle;
    const modal = document.getElementById('quick-view-modal');
    const content = document.getElementById('quick-view-content');

    modal.classList.add('active');

    content.innerHTML = `
      <div class="loading__spinner" style="display:flex; justify-content:center; align-items:center; min-height:300px;">
        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
          <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
        </svg>
      </div>
    `;

    try {
      const response = await fetch(`/products/${handle}`);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const productSection = doc.querySelector('product-info[data-product-id]');

      if (productSection) {
        // Remove modal-dialog elements to prevent custom element crash
        productSection.querySelectorAll('modal-dialog').forEach(el => el.remove());

        content.innerHTML = productSection.outerHTML;

        setTimeout(function () {
          if (typeof window.initPackSelector === 'function') {
            console.log('Quick View: calling initPackSelector');
            window.initPackSelector(content);
          } else {
            console.warn('Quick View: initPackSelector not defined');
          }

          const variantInput = content.querySelector('input[name="id"]');
          const variantId = variantInput ? variantInput.value : null;

          if (variantId && typeof window.syncWineMembersPrice === 'function') {
            console.log('Quick View: syncing wine member price for variant', variantId);
            window.syncWineMembersPrice(content, variantId);
          } else {
            console.warn('Quick View: variantId not found or sync function missing');
          }
        }, 150);

      } else {
        content.innerHTML = '<p>Product section not found</p>';
      }

    } catch (error) {
      console.error(error);
      content.innerHTML = '<p>Unable to load product.</p>';
    }

    return;
  }

  // CLOSE ON X BUTTON
  if (e.target.closest('.quick-view-close')) {
    console.log('Close Clicked');
    document.getElementById('quick-view-modal').classList.remove('active');
    document.getElementById('quick-view-content').innerHTML = '';
    return;
  }

  // CLOSE ON OVERLAY
  if (e.target.classList.contains('quick-view-overlay')) {
    console.log('Overlay Clicked');
    document.getElementById('quick-view-modal').classList.remove('active');
    document.getElementById('quick-view-content').innerHTML = '';
  }

});